import React, { useContext, useState } from 'react';
import { Layout, Col, Row, Menu, Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from 'src/utils/UserContext';
import { deleteToken } from 'src/services';
import userIcon from '../assets/images/userIcon.svg';
import logo from '../assets/images/logo.png';
import { PrimaryButton } from './Buttons';

const MenuItem = Menu.Item;

function Header({
    isAuthenticated,
    setIsAuthenticated,
}: {
    isAuthenticated: boolean;
    setIsAuthenticated?: (authenticated: boolean) => void;
}): JSX.Element {
    const [collapsed, setCollapsed] = useState(false);
    const handleToggleMenu = () => {
        setCollapsed(!collapsed);
    };

    const [selectedMenuItem, setSelectedMenuItem] = useState<string>('home');
    const navigate = useNavigate();
    const userContext = useContext(UserContext);
    let srcProfilePhoto: string | undefined;
    if (isAuthenticated) srcProfilePhoto = userContext.userState?.photo;
    return (
        <Layout.Header className="header" style={{ padding: '0px', paddingLeft: '10px', paddingRight: '10px' }}>
            {isAuthenticated ? (
                <Row className="align-self-center">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 7 }}
                        lg={{ span: 7 }}
                        className="padding-top-xs align-self-right"
                        style={{ justifyContent: 'flex-end', textAlign: 'center', padding: '10px' }}
                    >
                        <img src={logo} alt="logo" className="logo" />
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 17 }}
                        lg={{ span: 17 }}
                        style={{
                            background: '#0C6A54',
                            height: '80px',
                            borderRadius: '40px',
                            marginTop: '10px',
                            padding: '10px',
                        }}
                    >
                        <Row>
                            <Col
                                xs={{ span: 24 }}
                                sm={{ span: 24 }}
                                md={{ span: 24 }}
                                lg={{ span: 24 }}
                                className="align-self-right padding-right-md"
                            >
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Menu
                                        mode={collapsed ? 'vertical' : 'horizontal'}
                                        inlineCollapsed={collapsed}
                                        style={{
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            fontSize: '20px',
                                        }}
                                        className="menu"
                                    >
                                        <Menu.Item key="home">
                                            <a
                                                href="https://revenewcycle.com/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Home
                                            </a>
                                        </Menu.Item>
                                        <Menu.Item key="about">
                                            <a
                                                href="https://revenewcycle.com/about/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                About
                                            </a>
                                        </Menu.Item>
                                        <Menu.Item key="services">
                                            <a
                                                href="https://revenewcycle.com/services/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Services
                                            </a>
                                        </Menu.Item>
                                        <Menu.Item key="contact">
                                            <a
                                                href="https://revenewcycle.com/contact-us/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Contact
                                            </a>
                                        </Menu.Item>
                                    </Menu>

                                    <div
                                        className="float-right"
                                        style={{
                                            marginRight: '10px',
                                            height: '100%',
                                            alignItems: 'center',
                                            marginTop: '10px',
                                        }}
                                    >
                                        <Link to="/">
                                            <PrimaryButton
                                                styles={{
                                                    backgroundColor: '#EE773B',
                                                    borderRadius: '20px',
                                                    textAlign: 'center',
                                                    lineHeight: '25px',
                                                    fontSize: '18px',
                                                    height: '32px',
                                                    width: '100px',
                                                    padding: '0px',
                                                }}
                                                title="Logout"
                                                onClick={() => {
                                                    setIsAuthenticated?.(false);
                                                    deleteToken();
                                                    navigate('/');
                                                }}
                                            />
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            ) : (
                <>
                    <Row className="align-self-center">
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 7 }}
                            lg={{ span: 7 }}
                            className="padding-top-xs align-self-right"
                            style={{ justifyContent: 'flex-end', textAlign: 'center', padding: '10px' }}
                        >
                            <img src={logo} alt="logo" className="logo" />
                        </Col>
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 17 }}
                            lg={{ span: 17 }}
                            style={{
                                background: '#0C6A54',
                                height: '80px',
                                borderRadius: '40px',
                                marginTop: '10px',
                                padding: '10px',
                            }}
                        >
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 24 }}
                                    className="align-self-right padding-right-md"
                                >
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Menu
                                            className="menu"
                                            mode={collapsed ? 'vertical' : 'horizontal'}
                                            inlineCollapsed={collapsed}
                                            style={{
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                fontSize: '20px',
                                            }}
                                        >
                                            <Menu.Item key="home">
                                                <a
                                                    href="https://revenewcycle.com/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Home
                                                </a>
                                            </Menu.Item>
                                            <Menu.Item key="about">
                                                <a
                                                    href="https://revenewcycle.com/about/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    About
                                                </a>
                                            </Menu.Item>
                                            <Menu.Item key="services">
                                                <a
                                                    href="https://revenewcycle.com/services/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Services
                                                </a>
                                            </Menu.Item>
                                            <Menu.Item key="contact">
                                                <a
                                                    href="https://revenewcycle.com/contact-us/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Contact
                                                </a>
                                            </Menu.Item>
                                        </Menu>

                                        <div
                                            className="float-right auth"
                                            style={{
                                                marginRight: '10px',
                                                height: '100%',
                                                alignItems: 'center',
                                                marginTop: '10px',
                                            }}
                                        >
                                            <Link to="/">
                                                <PrimaryButton
                                                    title="Log In"
                                                    styles={{
                                                        backgroundColor: '#EE773B',
                                                        borderRadius: '20px',
                                                        textAlign: 'center',
                                                        lineHeight: '25px',
                                                        fontSize: '18px',
                                                        height: '32px',
                                                        width: '100px',
                                                        padding: '0px',
                                                    }}
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
            )}
        </Layout.Header>
    );
}

export default Header;
